import React from "react";
import "./FilterExpense.css";
function FilterExpense(props) {
  function filterYears(e) {
    const filteredExpenses = props.expenses.filter(
      (expense) => expense.date.getFullYear().toString() === e.target.value
    );
    props.onFilterExpenses(filteredExpenses);
  }

  return (
    <div className="expenses-filter">
      <div className="expenses-filter__control">
        <label>Filter by year</label>
        <select onChange={filterYears}>
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
        </select>
      </div>
    </div>
  );
}

export default FilterExpense;
